<template>
  <footer>

    <div class="row">
      <div class="column small-offset-1 small-22">

        <div class="row">
          <div class="column mediumlarge-8 medium-4 footer-cell logo-cell">
            <svg-icon
              v-if="isPoweredByMoqo"
              :name="poweredByImageName"
              :fill="moqoColor"
              size="large"
            ></svg-icon>
            <img v-else class="logo" :src="logoUrl"/>
          </div>

          <div class="column footer-cell  mediumlarge-8 mediumlarge-push-8   medium-10 medium-push-10">
            <div class="column medium-22 medium-offset-1 large-18 large-offset-3">
              <mobile-app v-if="teamsiteConfig.app" :app="teamsiteConfig.app"></mobile-app>
            </div>
          </div>

          <div class="column footer-cell  mediumlarge-8 mediumlarge-pull-8   medium-10 medium-pull-10">
            <div class="column medium-22 medium-offset-1 large-18 large-offset-3">
              <support-info ></support-info>
            </div>

          </div>



        </div>

        <div class="row">
          <div class="column text-center">
            <mq-navigation class="primary" :navItems="navItems"></mq-navigation>
          </div>
        </div>


      </div>
    </div>


  </footer>
</template>

<script>
  export default {
    name: 'TeamsiteFooter',

    props: {
      logoUrl: {
        required: true,
        type: String
      }
    },

    computed: {
      navItems () {
        let navItems = []

        let gtc = this.generalBusinessTermsDocument
        if (gtc) {
          navItems.push(
            { name: this.$t('footer.links.general_business_terms'), url: gtc.url }
          )
        }

        navItems.push(
          { name: this.$t('footer.links.site_notice'), url: this.routes.siteNoticeUrl },
          { name: this.$t('footer.links.privacy_policy'), url: this.routes.privacyPolicyUrl }
        )

        return navItems
      }
    }
  }
</script>

<style lang="scss">
footer {
  padding: rem-calc(40) 0 rem-calc(40);
  background-color: $color-white;

  .footer-cell {
    margin-bottom: rem-calc(40);
  }

  svg {
    width: 100%;
    height: auto;
  }
  .svg-icon {
    display: block;
    max-width: rem-calc(140);

    @include breakpoint(small only) {
      max-width: rem-calc(125);
    }
  }

  @include breakpoint(medium only){
    .svg-icon {
      width: 80%;
    }
  }

  @include breakpoint(small only){
    padding: rem-calc(20) 0 rem-calc(20);
    .logo-wrapper {
      text-align: center;
    }
    .svg-icon {
      margin: auto;
      width: 40%;
    }
  }

  p {
    font-size: rem-calc(16);
    line-height: rem-calc(18);
    margin-top: rem-calc(10);
    margin-bottom: rem-calc(20);
    &.bold {
      font-weight: bold;
    }
  }


  .logo {
    max-width: rem-calc(140);
    margin-bottom: rem-calc(80);

    @include breakpoint(small only){
      max-width: rem-calc(125);
      margin-bottom: rem-calc(50);
    }
  }

  ul.navigation {
    list-style: none;
    text-align: center;
    width: auto;
    margin: auto;
    margin-top: rem-calc(60);

    li {
      display: inline-block;
      float: none;
      padding: 0 1em;
      margin: 0;

      @include breakpoint(medium down) {
        padding: 0 0.5em;
      }
    }

    a, router-link {
      text-transform: none;
      font-size: rem-calc(12);
      font-weight: $font-weight-regular;
    }
  }

  ul.primary.navigation {
    text-align: center;
  }

  .logo-cell {
    @include breakpoint(small only){
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TeamsiteFooter.vue